import React from 'react';
import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

type Props = {
  open: boolean;
  title: string;
  purpose?: string;
  prerequisites?: string[];
  outputs?: string[];
  tips?: string[];
  onClose: () => void;
};

class FWorkbenchHelpDialog extends React.PureComponent<Props> {
  renderList(title: string, items?: string[]) {
    if (!items?.length) return null;

    return (
      <div>
        <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.5 }}>{title}</Typography>
        <ul style={{ marginTop: 0 }}>{items.map((x, i) => <li key={`${title}-${i}`}>{x}</li>)}</ul>
      </div>
    );
  }

  render() {
    const p = this.props;

    return (
      <Dialog open={p.open} onClose={p.onClose} maxWidth="md" fullWidth>
        <DialogTitle>{p.title}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            {p.purpose && (
              <div>
                <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.5 }}>Purpose</Typography>
                <Typography variant="body2">{p.purpose}</Typography>
              </div>
            )}
            {this.renderList('Prerequisites', p.prerequisites)}
            {this.renderList('Outputs', p.outputs)}
            {this.renderList('Tips', p.tips)}
          </Stack>
        </DialogContent>
      </Dialog>
    );
  }
}

export default FWorkbenchHelpDialog;
